import React, { useState, useEffect, useCallback, memo } from "react";
import maleCandidate from "../../../assets/maleCandidate.jpg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { API_URL } from "../../../constants";
import { FaSpinner } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { GetServiceCaller } from "../../../services/serviceCaller";
import "bootstrap/dist/css/bootstrap.min.css";
import { useDispatch } from "react-redux";
import {
  updateDashboardApiData,
  updateNavbarHeading,
} from "../../../constants/layout/store/filterSlice";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";
import Accordion from "react-bootstrap/Accordion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SnowflakeIcon from "../../../assets/SnowflakeIcon.svg";
import AIIcon from "../../../assets/AIIcon.svg";
import ITTipsIcon from "../../../assets/ITTipsIcon.svg";
import AdminIcon from "../../../assets/AdminIcon.svg";
import PBIcon from "../../../assets/PowerBIWhiteLogo.svg";
import DSPulseIcon from "../../../assets/DSLogo.svg";
import moment from "moment";

const KnowledgeSharing = ({ isSidebarOpen }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateNavbarHeading("Tech & Tips"));
    fetchSharingData();
  }, []);

  const [pageLoading, setPageLoading] = useState(true);
  const [leaderOpen, setLeaderOpen] = useState(true);
  const [leaveOpen, setLeaveOpen] = useState(false);
  const [activeKey, setActiveKey] = useState("0");

  // Search states
  const [searchQuery, setSearchQuery] = useState("");
  console.log("searchQuery::", searchQuery);

  const [searchResults, setSearchResults] = useState([]);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [allContent, setAllContent] = useState([]);

  const [tips, setTips] = useState({
    snowflake: [],
    weeklyDose: [],
    it: [],
    admin: [],
    powerbytes: [],
    dspulse:[]
  });

  const toggleLeaveOpen = () => {
    setLeaveOpen((prev) => !prev);
    if (!leaveOpen) {
      setLeaderOpen(false);
    }
  };

  const toggleLeaderOpen = () => {
    setLeaderOpen((prev) => !prev);
    if (!leaderOpen) {
      setLeaveOpen(false);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      const isTargetScreenSize = window.matchMedia(
        "(min-width: 1600px) and (max-width: 2199px)"
      ).matches;

      if (isTargetScreenSize) {
        setLeaderOpen(true);
        setLeaveOpen(true);
        // setActiveKey([]);
      } else {
        // setActiveKey(["0"]);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Build search index when tips data changes
  useEffect(() => {
    buildSearchIndex();
  }, [tips]);

  const buildSearchIndex = () => {
    const content = [];

    const categories = [
      { key: 'snowflake', name: 'Snowflake', eventKey: '0', data: tips.snowflake },
      { key: 'weeklyDose', name: 'Weekly Dose of AI', eventKey: '1', data: tips.weeklyDose },
      { key: 'it', name: 'IT Tips', eventKey: '2', data: tips.it },
      { key: 'admin', name: 'Admin Tips', eventKey: '3', data: tips.admin },
      { key: 'powerbytes', name: 'Power Bytes', eventKey: '4', data: tips.powerbytes },
      { key: 'dspulse', name: 'DS Pulse', eventKey: '5', data: tips.dspulse }
    ];

    categories.forEach(category => {
      category.data.forEach(item => {
        content.push({
          id: item.ID,
          title: item.title || '',
          message: item.Message || '',
          date: item.Date,
          filePath: item.FilePath,
          category: category.key,
          categoryName: category.name,
          eventKey: category.eventKey
        });
      });
    });

    setAllContent(content);
  };

  const highlightText = (text, query) => {
    if (!query || !text) return text;

    const regex = new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
    const parts = text.split(regex);

    return parts.map((part, index) =>
      regex.test(part) ?
        <span key={index} style={{
          background: 'linear-gradient(120deg, #fbbf24 0%, #f59e0b 100%)',
          color: '#92400e',
          padding: '2px 6px',
          borderRadius: '4px',
          fontWeight: '600'
        }}>
          {part}
        </span> : part
    );
  };

  const performSearch = useCallback((query) => {
    if (query.length < 2) {
      setSearchResults([]);
      setShowSearchResults(false);
      return;
    }

    const filtered = allContent.filter(item =>
      item.title.toLowerCase().includes(query.toLowerCase()) ||
      item.message.toLowerCase().includes(query.toLowerCase())
    );

    setSearchResults(filtered);
    setShowSearchResults(filtered.length > 0);
  }, [allContent]);

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    performSearch(query);
  };

  const handleSearchFocus = () => {
    if (searchQuery.length >= 2) {
      performSearch(searchQuery);
    }
  };

  const handleResultClick = (result) => {
    // Close search results
    setShowSearchResults(false);
    setSearchQuery('');

    // Open the relevant accordion
    setActiveKey(result.eventKey);

    // Scroll to top after a small delay to allow accordion to open
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 300);
  };

  // Close search results when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.search-wrapper')) {
        setShowSearchResults(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  const fetchSharingData = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}nest/dashboard/knowledge-sharing`
      );

      const sharingData = response?.data?.tips;

      setTips({
        snowflake: sharingData?.snowFlake || [],
        weeklyDose: sharingData?.weeklyDose || [],
        it: sharingData?.itTips || [],
        admin: sharingData?.adminFeeds || [],
        powerbytes: sharingData?.powerbytes || [],
        dspulse: sharingData?.dspulse || []
      });

      setPageLoading(false);
    } catch (error) {
      console.error("Error fetching skills:", error);
      setPageLoading(false);
    }
  };

  const handleToggle = (key) => {
    setActiveKey((prevActiveKey) => (prevActiveKey === key ? null : key));
  };

  if (pageLoading) {
    return (
      <p className="position-absolute top-50 start-50 translate-middle text-center">
        <FaSpinner className="spinner" />
      </p>
    );
  }

  return (
    <>
      <div className="container-fluid">
        <div className="row mt-2 mx-0">
          <div className="col-md-12 p-0 m-0">
            <div className="container-fluid m-0" id="skill-table-area">

              {/* Global Search Section */}
              <div className="search-container">
                <div className="search-wrapper">
                  <input
                    type="text"
                    className="search-input"
                    placeholder="Search across all sections..."
                    value={searchQuery}
                    onChange={handleSearchChange}
                    onFocus={handleSearchFocus}
                  />
                  <div className="search-icon">🔍</div>

                  {/* Search Results */}
                  {showSearchResults && searchResults.length > 0 && (
                    <div className="search-results" style={{ display: 'block' }}>
                      {searchResults.map((result) => (
                        <div
                          key={`${result.category}-${result.id}`}
                          className="search-result-item"
                          onClick={() => handleResultClick(result)}
                        >
                          <div className="search-result-title">
                            {highlightText(result.title, searchQuery)}
                          </div>
                          <div className="search-result-category">
                            {result.categoryName}
                          </div>
                          <div className="search-result-preview">
                            {highlightText(
                              result.message.length > 100
                                ? result.message.substring(0, 100) + '...'
                                : result.message,
                              searchQuery
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {/* Accordion Content */}
              <div className="row mt-2">
                <div className="container-fluid">
                  <Accordion activeKey={activeKey} onSelect={handleToggle}>

                    {/* Snowflake Section */}
                    <Accordion.Item eventKey="0">
                      <Accordion.Header className="knowledge-share-Accordion">
                        <div className="flex-grow-1 fw-bold" style={{ color: "#141468" }}>
                          Snowflake
                        </div>
                        <span className="me-2 accordion_icon text-white">
                          <FontAwesomeIcon
                            icon={activeKey === "0" ? faMinus : faPlus}
                            style={{ color: "#141468" }}
                          />
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="row g-3">
                          {tips?.snowflake?.map((item) => (
                            <div className="col-md-3" key={item.ID}>
                              <div className="card">
                                <div className="knowledge-card-header-section">
                                  <div className="banner-background snowFlake-background"></div>
                                  <div className="KnowledgeSharingSection">
                                    <div>
                                      <img
                                        src={SnowflakeIcon}
                                        alt="image"
                                        className="knowledgeIcon"
                                      />
                                    </div>
                                    <h5 className="text-white mt-2">SnowFlake</h5>
                                  </div>
                                </div>
                                <span className="knowledge-Date">
                                  {moment(item.Date).format("DD-MMM-YYYY")}
                                </span>
                                <div className="card-body" style={{ padding: "0px 6px" }}>
                                  <h6 className="p-0 m-0">
                                    <b>{item.title}</b>
                                  </h6>
                                  <p className="m-1" style={{ paddingBottom: "10px" }}>
                                    {(() => {
                                      const text = (item?.Message || "").trim();
                                      const isLargeScreen = window.innerWidth >= 1600;
                                      const max = 150;
                                      if (isLargeScreen) {
                                        return text;
                                      } else {
                                        return text.length > max ? text.slice(0, max) + "..." : text;
                                      }
                                    })()}
                                  </p>
                                  {item?.FilePath && (
                                    <div className="d-flex justify-content-end mb-2">
                                      <a
                                        href={item.FilePath}
                                        target="_blank"
                                        className="btn"
                                        style={{
                                          backgroundColor: "#3781E2",
                                          border: "none",
                                          color: "#fff",
                                          fontWeight: "500",
                                          padding: "5px 10px",
                                          fontSize: "10px",
                                        }}
                                      >
                                        Open
                                      </a>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    {/* Weekly Dose of AI Section */}
                    <Accordion.Item eventKey="1">
                      <Accordion.Header className="knowledge-share-Accordion">
                        <div className="flex-grow-1 fw-bold" style={{ color: "#141468" }}>
                          Weekly Dose of AI
                        </div>
                        <span className="me-2 accordion_icon">
                          <FontAwesomeIcon
                            icon={activeKey === "1" ? faMinus : faPlus}
                            style={{ color: "#141468" }}
                          />
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="row g-3">
                          {tips?.weeklyDose?.map((item) => (
                            <div className="col-md-3" key={item.ID}>
                              <div className="card" style={{ cursor: "default" }}>
                                <div className="knowledge-card-header-section">
                                  <div className="banner-background AI-background"></div>
                                  <div className="KnowledgeSharingSection">
                                    <div>
                                      <img src={AIIcon} alt="image" className="knowledgeIcon" />
                                    </div>
                                    <h5 className="text-white mt-2">Weekly Dose Of AI</h5>
                                  </div>
                                </div>
                                <span className="knowledge-Date">
                                  {moment(item.Date).format("DD-MMM-YYYY")}
                                </span>
                                <div className="card-body" style={{ padding: "0px 6px" }}>
                                  <h6 className="p-0 m-0">
                                    <b>{item.title}</b>
                                  </h6>
                                  <p className="m-0" style={{ paddingBottom: "10px" }}>
                                    {(() => {
                                      const text = (item?.Message || "").trim();
                                      const isLargeScreen = window.innerWidth >= 1600;
                                      const max = 150;
                                      if (isLargeScreen) {
                                        return text;
                                      } else {
                                        return text.length > max ? text.slice(0, max) + "..." : text;
                                      }
                                    })()}
                                  </p>
                                  {item?.FilePath && (
                                    <div className="d-flex justify-content-end mb-2">
                                      <a
                                        href={item.FilePath}
                                        target="_blank"
                                        className="btn"
                                        style={{
                                          backgroundColor: "#3781E2",
                                          border: "none",
                                          color: "#fff",
                                          fontWeight: "500",
                                          padding: "5px 10px",
                                          fontSize: "10px",
                                        }}
                                      >
                                        Open
                                      </a>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    {/* IT Tips Section */}
                    <Accordion.Item eventKey="2">
                      <Accordion.Header className="knowledge-share-Accordion">
                        <div className="flex-grow-1 fw-bold" style={{ color: "#141468" }}>
                          IT Tips
                        </div>
                        <span className="me-2 accordion_icon">
                          <FontAwesomeIcon
                            icon={activeKey === "2" ? faMinus : faPlus}
                            style={{ color: "#141468" }}
                          />
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="row g-3">
                          {tips?.it?.map((item) => (
                            <div className="col-md-3" key={item.ID}>
                              <div className="card" style={{ cursor: "default" }}>
                                <div className="knowledge-card-header-section">
                                  <div className="banner-background IT-background"></div>
                                  <div className="KnowledgeSharingSection">
                                    <div>
                                      <img src={ITTipsIcon} alt="image" className="knowledgeIcon" />
                                    </div>
                                    <h5 className="text-white mt-2">IT Tips</h5>
                                  </div>
                                </div>
                                <span className="knowledge-Date">
                                  {moment(item.Date).format("DD-MMM-YYYY")}
                                </span>
                                <div className="card-body" style={{ padding: "0px 6px" }}>
                                  <h6 className="p-0 m-0">
                                    <b>{item.title}</b>
                                  </h6>
                                  <p className="m-0" style={{ paddingBottom: "10px" }}>
                                    {(() => {
                                      const text = (item?.Message || "").trim();
                                      const isLargeScreen = window.innerWidth >= 1600;
                                      const max = 150;
                                      if (isLargeScreen) {
                                        return text;
                                      } else {
                                        return text.length > max ? text.slice(0, max) + "..." : text;
                                      }
                                    })()}
                                  </p>
                                  {item?.FilePath && (
                                    <div className="d-flex justify-content-end mb-2">
                                      <a
                                        href={item.FilePath}
                                        target="_blank"
                                        className="btn"
                                        style={{
                                          backgroundColor: "#3781E2",
                                          border: "none",
                                          color: "#fff",
                                          fontWeight: "500",
                                          padding: "5px 10px",
                                          fontSize: "10px",
                                        }}
                                      >
                                        Open
                                      </a>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>

                    {/* Admin Tips Section */}
                    <Accordion.Item eventKey="3">
                      <Accordion.Header className="knowledge-share-Accordion">
                        <div className="flex-grow-1 fw-bold" style={{ color: "#141468" }}>
                          Admin Tips
                        </div>
                        <span className="me-2 accordion_icon">
                          <FontAwesomeIcon
                            icon={activeKey === "3" ? faMinus : faPlus}
                            style={{ color: "#141468" }}
                          />
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="row g-3">
                          {tips?.admin?.map((item) => (
                            <div className="col-md-3" key={item.ID}>
                              <div className="card" style={{ cursor: "default" }}>
                                <div className="knowledge-card-header-section">
                                  <div className="banner-background admin-background"></div>
                                  <div className="KnowledgeSharingSection">
                                    <div>
                                      <img src={AdminIcon} alt="image" className="knowledgeIcon" />
                                    </div>
                                    <h5 className="text-white mt-2">Admin Tips</h5>
                                  </div>
                                </div>
                                <span className="knowledge-Date">
                                  {moment(item.Date).format("DD-MMM-YYYY")}
                                </span>
                                <div className="card-body" style={{ padding: "0px 6px" }}>
                                  <h6 className="p-0 m-0">
                                    <b>{item.title}</b>
                                  </h6>
                                  <p className="m-0" style={{ paddingBottom: "10px" }}>
                                    {(() => {
                                      const text = (item?.Message || "").trim();
                                      const isLargeScreen = window.innerWidth >= 1600;
                                      const max = 150;
                                      if (isLargeScreen) {
                                        return text;
                                      } else {
                                        return text.length > max ? text.slice(0, max) + "..." : text;
                                      }
                                    })()}
                                  </p>
                                  {item?.FilePath && (
                                    <div className="d-flex justify-content-end mb-2">
                                      <a
                                        href={item.FilePath}
                                        target="_blank"
                                        className="btn"
                                        style={{
                                          backgroundColor: "#3781E2",
                                          border: "none",
                                          color: "#fff",
                                          fontWeight: "500",
                                          padding: "5px 10px",
                                          fontSize: "10px",
                                        }}
                                      >
                                        Open
                                      </a>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                     {/* Power Bytes Section */}
                    <Accordion.Item eventKey="4">
                      <Accordion.Header className="knowledge-share-Accordion">
                        <div className="flex-grow-1 fw-bold" style={{ color: "#141468" }}>
                          Power Bytes
                        </div>
                        <span className="me-2 accordion_icon">
                          <FontAwesomeIcon
                            icon={activeKey === "4" ? faMinus : faPlus}
                            style={{ color: "#141468" }}
                          />
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="row g-3">
                          {tips?.powerbytes?.map((item) => (
                            <div className="col-md-3" key={item.ID}>
                              <div className="card" style={{ cursor: "default" }}>
                                <div className="knowledge-card-header-section">
                                  <div className="banner-background powerbyte-background"></div>
                                  <div className="KnowledgeSharingSection">
                                    <div>
                                      <img src={PBIcon} alt="image" className="knowledgeIcon" />
                                    </div>
                                    <h5 className="text-white mt-2">Power Bytes</h5>
                                  </div>
                                </div>
                                <span className="knowledge-Date">
                                  {moment(item.Date).format("DD-MMM-YYYY")}
                                </span>
                                <div className="card-body" style={{ padding: "0px 6px" }}>
                                  <h6 className="p-0 m-0">
                                    <b>{item.title}</b>
                                  </h6>
                                  <p className="m-0" style={{ paddingBottom: "10px" }}>
                                    {(() => {
                                      const text = (item?.Message || "").trim();
                                      const isLargeScreen = window.innerWidth >= 1600;
                                      const max = 150;
                                      if (isLargeScreen) {
                                        return text;
                                      } else {
                                        return text.length > max ? text.slice(0, max) + "..." : text;
                                      }
                                    })()}
                                  </p>
                                  {item?.FilePath && (
                                    <div className="d-flex justify-content-end mb-2">
                                      <a
                                        href={item.FilePath}
                                        target="_blank"
                                        className="btn"
                                        style={{
                                          backgroundColor: "#3781E2",
                                          border: "none",
                                          color: "#fff",
                                          fontWeight: "500",
                                          padding: "5px 10px",
                                          fontSize: "10px",
                                        }}
                                      >
                                        Open
                                      </a>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                    {/* DS Pulse */}
                    <Accordion.Item eventKey="5">
                      <Accordion.Header className="knowledge-share-Accordion">
                        <div className="flex-grow-1 fw-bold" style={{ color: "#141468" }}>
                          DS Pulse
                        </div>
                        <span className="me-2 accordion_icon">
                          <FontAwesomeIcon
                            icon={activeKey === "4" ? faMinus : faPlus}
                            style={{ color: "#141468" }}
                          />
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="row g-3">
                          {tips?.dspulse?.map((item) => (
                            <div className="col-md-3" key={item.ID}>
                              <div className="card" style={{ cursor: "default" }}>
                                <div className="knowledge-card-header-section">
                                  <div className="banner-background dspulse-background"></div>
                                  <div className="KnowledgeSharingSection">
                                    <div>
                                      <img src={DSPulseIcon} alt="image" className="knowledgeIcon" />
                                    </div>
                                    <h5 className="text-white mt-2">DS Pulse</h5>
                                  </div>
                                </div>
                                <span className="knowledge-Date">
                                  {moment(item.Date).format("DD-MMM-YYYY")}
                                </span>
                                <div className="card-body" style={{ padding: "0px 6px" }}>
                                  <h6 className="p-0 m-0">
                                    <b>{item.title}</b>
                                  </h6>
                                  <p className="m-0" style={{ paddingBottom: "10px" }}>
                                    {(() => {
                                      const text = (item?.Message || "").trim();
                                      const isLargeScreen = window.innerWidth >= 1600;
                                      const max = 150;
                                      if (isLargeScreen) {
                                        return text;
                                      } else {
                                        return text.length > max ? text.slice(0, max) + "..." : text;
                                      }
                                    })()}
                                  </p>
                                  {item?.FilePath && (
                                    <div className="d-flex justify-content-end mb-2">
                                      <a
                                        href={item.FilePath}
                                        target="_blank"
                                        className="btn"
                                        style={{
                                          backgroundColor: "#3781E2",
                                          border: "none",
                                          color: "#fff",
                                          fontWeight: "500",
                                          padding: "5px 10px",
                                          fontSize: "10px",
                                        }}
                                      >
                                        Open
                                      </a>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .search-container {
          padding: 10px 20px;
          background: linear-gradient(to bottom, #f8fafc, #e2e8f0);
        }

        .search-wrapper {
          position: relative;
          max-width: 400px;
          margin: 0 20%;
        }

        .search-input {
          width: 100%;
          padding: 8px 10px 8px 40px;
          font-size: 18px;
          border: 2px solid #e2e8f0;
          border-radius: 15px;
          background: white;
          outline: none;
          transition: all 0.3s ease;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
        }

        .search-input:focus {
          border-color: #667eea;
          box-shadow: 0 8px 25px rgba(102, 126, 234, 0.15);
          transform: translateY(-2px);
        }

        .search-icon {
          position: absolute;
          right: 20px;
          top: 50%;
          transform: translateY(-50%);
          color: #94a3b8;
          font-size: 20px;
          pointer-events: none;
        }

        .search-results {
          position: absolute;
          top: 100%;
          left: 0;
          right: 0;
          margin-top: 10px;
          background: white;
          border-radius: 15px;
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
          max-height: 300px;
          overflow-y: auto;
          z-index: 1000;
          display: none;
        }

        .search-result-item {
          padding: 15px 20px;
          border-bottom: 1px solid #f1f5f9;
          cursor: pointer;
          transition: background 0.2s ease;
        }

        .search-result-item:hover {
          background: #f8fafc;
        }

        .search-result-item:last-child {
          border-bottom: none;
        }

        .search-result-title {
          font-weight: 600;
          color: #1e293b;
          margin-bottom: 5px;
          font-size: 14px;
        }

        .search-result-category {
          font-size: 12px;
          color: #667eea;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          font-weight: 600;
          margin-bottom: 5px;
        }

        .search-result-preview {
          font-size: 12px;
          color: #64748b;
          line-height: 1.4;
        }

        @media (max-width: 768px) {
          .search-container {
            padding: 15px 10px;
          }
          
          .search-input {
            padding: 15px 50px 15px 20px;
            font-size: 16px;
          }
        }
      `}</style>
    </>
  );
};

export default KnowledgeSharing;